import React, { useState, useEffect, useCallback } from "react";
import Loader from "react-loader-spinner";

import BankTransfer from "./bank/BankTransfer";
import BankTransferDetails from "./bank/BankTransferDetails";
import BankTransferSucces from "./bank/BankTransferSucces";
import BankTranferVerify from "./bank/BankTransferVerify";
import AddNewBankCard from "./card/AddNewBankCard";
import CardAmountInput from "./card/CardAmountInput";
import { colors } from "../../../../Syles/styles";
// import CardPayment from "./card/CardAmountInput";
import CardFunding from "./card/CardFunding";
// import CardSuccess from "./card/CardPayment";
import CardPaymentSuccess from "./card/CardPaymentSuccess";
import FundWalletMethod from "./FundWalletMethod";
import "./fundwallet.css";

import backicon from "../../../../Assets/backicon.svg";
import SelectWallet from "./SelectWallet";
import { $api } from "../../../../../helpers/$api";
import { useUser } from "../../../../../hooks/use-user";

const FundWalletLogic = ({ stage, setStage, stageEmit }) => {
  let currentStage;
  const [paymentOpts, setOpts] = useState(null);
  const user = useUser();
  const hasOnlyDollar =
    !user.country.toLowerCase().includes("nigeria") &&
    !user.country.toLowerCase().includes("ghana");

  const getUserPaymentOptions = useCallback(async () => {
    try {
      const opts = await $api.user.getUserPaymentOptions();

      setOpts({ ...opts });
    } catch (error) {
      // error getting opts...
    }
  }, [setOpts]);

  useEffect(() => {
    getUserPaymentOptions();
  }, [getUserPaymentOptions]);

  if (!paymentOpts) {
    return (
      <div className="current-stage">
        <div
          style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Loader
            type="ThreeDots"
            color={colors.primary}
            height={100}
            width={100}
            timeout={1e10}
          />
        </div>
      </div>
    );
  }

  switch (stage) {
    case 0:
    case 1:
      currentStage =
        paymentOpts.dollar && !hasOnlyDollar && stage === 0 ? (
          <SelectWallet setStage={setStage} />
        ) : (
          <>
            {paymentOpts.dollar && !hasOnlyDollar && (
              <button
                className="backicon"
                onClick={() => {
                  setStage(0);
                }}
              >
                <img src={backicon} alt="back icon" />
              </button>
            )}

            <FundWalletMethod setStage={setStage} data={stageEmit} />
          </>
        );
      break;

    case 2:
      currentStage = (
        <>
          <button
            className="backicon"
            onClick={() => {
              setStage(paymentOpts.dollar ? 1 : 0);
            }}
          >
            <img src={backicon} alt="back icon" />
          </button>
          <BankTransfer setStage={setStage} />
        </>
      );
      break;

    case 3:
      currentStage = (
        <>
          <button
            className="backicon"
            onClick={() => {
              setStage(2);
            }}
          >
            <img src={backicon} alt="back icon" />
          </button>
          <BankTransferDetails setStage={setStage} />
        </>
      );
      break;

    case 4:
      currentStage = (
        <>
          <button
            className="backicon"
            onClick={() => {
              setStage(3);
            }}
          >
            <img src={backicon} alt="back icon" />
          </button>
          <BankTranferVerify setStage={setStage} />
        </>
      );
      break;
    case 5:
      currentStage = (
        <>
          {/* <button
            className="backicon"
            onClick={() => {
              setStage(2);
            }}
          >
            <img src={backicon} alt="back icon" />
          </button> */}
          <BankTransferSucces setStage={setStage} />
        </>
      );
      break;

    case 6:
      currentStage = (
        <>
          <button
            onClick={() => {
              setStage(paymentOpts.dollar ? 1 : 0);
            }}
            style={{
              border: "none",
              background: "none",
              marginLeft: "34px",
              marginTop: "25px",
            }}
          >
            <img src={backicon} alt="back icon" />
          </button>
          <CardFunding setStage={setStage} data={stageEmit} />
        </>
      );
      break;

    case 7:
      currentStage = (
        <>
          <button
            onClick={() => {
              setStage(6);
            }}
            style={{
              border: "none",
              background: "none",
              marginLeft: "34px",
              marginTop: "25px",
            }}
          >
            <img src={backicon} alt="back icon" />
          </button>
          <AddNewBankCard setStage={setStage} stageEmit={stageEmit} />
        </>
      );
      break;

    case 8:
      currentStage = (
        <CardAmountInput setStage={setStage} stageEmit={stageEmit} />
      );
      break;

    case 9:
      currentStage = <CardPaymentSuccess setStage={setStage} />;
      break;

    default:
      currentStage = <FundWalletMethod setStage={setStage} />;
      break;
  }

  return <div className="current-stage">{currentStage}</div>;
};

export default FundWalletLogic;
